import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { ProfilePicture, Tooltip, Typography } from 'src/components/common';
import { textEllipsis, timeAgo } from 'src/utils';
import { TTextEllipsisResponse } from 'src/utils/textEllipsis/textEllipsis.types';

import { TDiscussionGroupItemProps } from './discussionGroupItem.types';
import './discussionGroupItem.scss';
import { TDiscussionTypes } from 'src/components/chat/chat.type';
import { groupicon } from 'src/assets/images';
import useGetDiscussionGroupMembers from '../useGetDiscussionGroupMembers';
import { colors } from 'src/constants';
import { markChatAsRead } from 'src/store/chat/chat.slice';
import { useAppDispatch } from 'src/store/hooks';

const DiscussionGroupItem = ({
  group,
  groupId,
  discussionType,
  programId
}: TDiscussionGroupItemProps) => {
  // Hooks
  const navigate = useNavigate();
  const dispatch = useAppDispatch()
  useGetDiscussionGroupMembers({ groupId });
  const groupTitleEllipsis: TTextEllipsisResponse = textEllipsis({
    text: group?.groupName,
    charLimit: 20
  });

  const viewPGroupDiscussion = () => {
    if (group?.id === groupId && discussionType === 'programGroup') {
      return
    }
    const { pathname } = window.location;
    const chatType: TDiscussionTypes = 'programGroup';
    // dispatch(markChatAsRead({ chatId: group?.id }));
    const path: string =
      pathname + `?id=${programId}&tab=discussion&chatType=${chatType}&groupId=${group?.id}`;

    navigate(path);
  };
  
  return (
    <div
      className={classNames('chat-list-user-card', {
        'chat-list-user-card--is-selected': group?.id === groupId && discussionType === 'programGroup'
      })}
      onClick={viewPGroupDiscussion}
    >
      <div className="chat-list-user-card__left">
        {/* <img src={groupicon} alt={group?.groupName} /> */}
        <ProfilePicture url={groupicon} fallback={'n'} />
        <div className="chat-list-user-card__left__user-details">
          <Tooltip
            text={group?.groupName}
            conditionToDisplay={groupTitleEllipsis?.hasEllipsis}
            limitWidth
          >
            <Typography
              as="p"
              variant="body-2"
              fontWeight="medium"
              className="namePerson"
            // style={{ color: colors?.neutral?.[1100] }}
            >
              {groupTitleEllipsis?.text}
            </Typography>
          </Tooltip>
          <Typography
            as="p"
            variant="caption"
            fontWeight="regular"
            className='profileRole'
          // style={{ color: colors?.neutral?.[900] }}
          >
            Group
          </Typography>
        </div>
      </div>
      <div className="chat-list-user-card__right">
        <Typography
          as="span"
          variant="caption"
          fontWeight="semiBold"
          className={classNames('chat-list-user-card__right__unread-count', {
            'chat-list-user-card__right__unread-count--is-hidden': group?.unreadMessageCount < 1
          })}
        >
          {group?.unreadMessageCount}
        </Typography>
        <Typography
          as="p"
          variant="caption"
          fontWeight="regular"
          style={{ color: colors?.neutral?.[700] }}
          className="chat-list-user-card__right__updated-at"
        >
          {timeAgo({ timestamp: group?.updatedAt })}
        </Typography>
      </div>
    </div>
    // <Tooltip
    //   text={group?.groupName}
    //   conditionToDisplay={groupTitleEllipsis?.hasEllipsis}
    //   limitWidth
    // >
    //   <Typography
    //     as="p"
    //     variant="body-2"
    //     fontWeight="semiBold"
    //     className={classNames('discussion-group-item', {
    //       'discussion-group-item--is-active':
    //         group?.id === groupId && discussionType === 'programGroup'
    //     })}
    //     onClick={viewPGroupDiscussion}
    //   >
    //     {groupTitleEllipsis?.text}
    //   </Typography>
    // </Tooltip>
  );
};

export default DiscussionGroupItem;
